import { isInteger, isSafeNumber, LosslessNumber } from 'lossless-json';

export function retainSafeNumber(value: string): number | LosslessNumber {
  if (isSafeNumber(value) || !isInteger(value)) {
    return parseFloat(value);
  }

  return new LosslessNumber(value);
}
